export default "__VITE_ASSET__BKJuWebO__"